import * as numbers from "./methods/numbers";
import * as strings from "./methods/strings";
import * as date from "./methods/date";
import * as other from "./methods/other";

export const methods = {};

webix.extend(methods, numbers);
webix.extend(methods, strings);
webix.extend(methods, date);
webix.extend(methods, other);

export function addMethod(name, handler){
	methods[name] = handler;
}